import React from "react";
import { Routes, Route } from "react-router-dom";
import { Box, Typography, Alert } from "@mui/material";
import GroupChatHome from "./GroupChatHome";
import GroupChatRoom from "./GroupChatRoom";

/**
 * GroupChatPage - React MUI routing component for Group Chat functionality
 *
 * This component provides:
 * - Routing for group chat home and individual rooms
 * - Navigation between group chat views
 * - Error boundary for group chat sections
 */

const GroupChatPage: React.FC = () => {
  return (
    <Box sx={{ height: "100%" }}>
      <Routes>
        <Route index element={<GroupChatHome />} />
        <Route path="room/:roomId" element={<GroupChatRoom />} />
        <Route
          path="*"
          element={
            <Box sx={{ p: 3, textAlign: "center" }}>
              <Alert severity="warning" sx={{ maxWidth: 600, mx: "auto" }}>
                <Typography variant="h6" gutterBottom>
                  Group Chat Page Not Found
                </Typography>
                <Typography variant="body2">
                  The group chat page you're looking for doesn't exist. Please
                  check the URL or navigate back to the group chat home.
                </Typography>
              </Alert>
            </Box>
          }
        />
      </Routes>
    </Box>
  );
};

export default GroupChatPage;
